import type { NiftiHeaderInfo } from "@/ipc/contract";

const XFORM: Record<number, string> = {
  0: "unknown",
  1: "scanner",
  2: "aligned",
  3: "Talairach",
  4: "MNI-152",
};

export function xformName(code: number): string {
  return XFORM[code] ?? String(code);
}

export function formatAffine(affine: number[][] | undefined | null): string {
  if (!affine?.length) return "";
  return affine
    .map((row) => row.map((n) => (Number.isFinite(n) ? n.toFixed(4) : "0")).join("  "))
    .join("\n");
}

export function formatHeader(info: NiftiHeaderInfo, focus?: string): { label: string; value: string }[] {
  const dim = info.dim.join(" × ");
  const pix = info.pixdim.slice(0, 3).map((n) => n.toFixed(3)).join(" × ");
  const rows: { label: string; value: string }[] = [
    { label: "File", value: info.path },
    { label: "Dimensions", value: dim },
    { label: "Voxel size (mm)", value: pix },
    { label: "Volumes", value: String(info.volumeCount ?? 1) },
    { label: "Datatype", value: info.datatype },
    { label: "Orientation", value: info.orientation },
    { label: "Compressed", value: info.isCompressed ? "Yes" : "No" },
  ];
  if (info.voxelVolumeMm3) {
    rows.push({ label: "Voxel volume", value: `${info.voxelVolumeMm3.toFixed(3)} mm³` });
  }
  rows.push(
    { label: "qform", value: `${info.qformCode} (${xformName(info.qformCode)})` },
    { label: "sform", value: `${info.sformCode} (${xformName(info.sformCode)})` },
    { label: "scl_slope", value: String(info.scaleSlope) },
    { label: "scl_inter", value: String(info.scaleInter) },
  );
  if (info.affine?.length && (focus === "affine" || !focus || focus === "header")) {
    rows.push({ label: "Affine", value: formatAffine(info.affine) });
  }
  return rows;
}
